// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3RdK0","search":"Settings_search__3HLNX","filter":"Settings_filter__3eovv"};